// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { app } from './app';

export const db = getFirestore(app);
// connectFirestoreEmulator(db, 'localhost', 8080);

